<template>
  <div>
    <el-upload
      class="upload-demo"
      :action="actionUrl"
      accept="image/jpg,image/jpeg,image/png"
      :on-success="handleSuccess"
      :show-file-list="false"
      :file-list="imgList"
      :headers="postHeader"
      :limit="1">
      <el-button size="small">{{btnTitle}}</el-button>
    </el-upload>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    btnTitle: {
      type: String,
      default: '点击上传',
    }
  },
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      actionUrl: "/api/v3/material/upload/",
      imgList: [],
      drag: false,
      is_draggable: false,
      uploadHeaders: {},
      is_message: false
    };
  },
  computed: mapState({
    postHeader: (state) => {
      return {
        Authorization: state.token,
      };
    },
  }),
  methods: {
    handleSuccess(res, file, fileList) {
      if (res) {
        file.response_url = res.url;
        this.$emit("OnImgChange", fileList);
        this.imgList = []
      }
    },
  }
}
</script>